import { Navigate, Outlet } from "react-router";
import { usePortalSettings } from "../api/hooks/usePortalSettings";
import { routePaths } from "./route-paths";

/** The portfolio tracker, or the dashboard where it is switched off, including for a saved link. */
export function RequirePortfolioTracker() {
  const settings = usePortalSettings();

  if (settings.isPending) {
    return null;
  }

  return settings.data?.portfolioTrackerEnabled ? (
    <Outlet />
  ) : (
    <Navigate to={routePaths.dashboard} replace />
  );
}
